import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import App from './App';
import LoadingScreen from './components/Layout/LoadingScreen';
import './index.css';
import './pages/Enhanced/global-enhanced.css';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Initialize the root with loading state
const root = createRoot(document.getElementById('root')!);

// Render the app with proper initialization
root.render(
  <StrictMode>
    <Suspense fallback={<LoadingScreen message="Application" />}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </Suspense>
  </StrictMode>
);
